<template>
  <div class="w-full bg-white rounded border flex flex-col">
    <slot name="toolbar" />
    <div class="p-4 w-full m-auto flex flex-col" v-if="!nocontent">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "LContainer",
  props: ["nocontent"]
};
</script>
